import { useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { ReactComponent as PlayIcon } from "../assets/icons/MusicPlay.svg";
import { ReactComponent as PauseIcon } from "../assets/icons/MusicPause.svg";

const RelaxationMusic = () => {
  const {
    state: { name, data },
  } = useLocation();
  const playerRef = useRef();
  const [audioState, setAudioState] = useState({ playing: false, src: "" });
  return (
    <div className="w-full pb-36">
      <div className="px-6">
        <div className="flex items-center mb-5">
          <Link to={-1} className="mr-3">
            <svg
              width="6"
              height="10"
              viewBox="0 0 10 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.42402 16.2142C9.99277 15.6454 9.99277 14.7267 9.42402 14.1579L3.76569 8.49959L9.42402 2.84126C9.99277 2.27251 9.99277 1.35376 9.42402 0.785009C8.85527 0.216259 7.93652 0.216259 7.36777 0.785009L0.674024 7.47876C0.105274 8.04751 0.105274 8.96626 0.674024 9.53501L7.36777 16.2288C7.92194 16.7829 8.85527 16.7829 9.42402 16.2142Z"
                fill="#fff"
              />
            </svg>
          </Link>
          <h3 className="text-white text-[14px] font-semibold">{name}</h3>
        </div>
      </div>
      <div className="px-6 flex flex-col items-stretch justify-between space-y-3">
        {data.map((music, index) => (
          <button
            key={`music-${index}`}
            type="button"
            onClick={() =>
              setAudioState((s) => {
                const newData =
                  s.src === music.tab_content_music
                    ? { ...s, playing: !s.playing }
                    : { playing: true, src: music.tab_content_music };
                if (newData.playing) {
                  if (s.src?.length > 0)
                    playerRef.current?.audio?.current?.play?.();
                } else playerRef.current?.audio?.current?.pause?.();
                return newData;
              })
            }
            className="px-4 py-2.5 rounded-xl bg-gradient-to-t from-[#5517A7]/30 to-[#331879]/30 flex items-center justify-between text-left"
          >
            <svg className="shrink-0 h-7" viewBox="0 0 512.000000 512.000000">
              <g
                transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                fill="#A359FF"
                stroke="none"
              >
                <path d="M4053 4850 c-40 -16 -43 -38 -43 -308 l0 -259 -70 5 c-115 8 -206 -44 -251 -142 -22 -49 -25 -152 -5 -200 68 -164 284 -206 410 -80 66 65 76 106 76 301 0 90 3 163 7 163 5 0 113 -32 240 -72 l233 -72 0 -53 c0 -52 -1 -54 -22 -47 -68 21 -167 0 -234 -51 -111 -85 -110 -290 2 -384 137 -113 344 -52 402 118 8 24 12 158 12 436 0 369 -1 405 -18 424 -13 17 -102 49 -352 126 -184 58 -342 104 -350 104 -8 0 -25 -4 -37 -9z m357 -253 l235 -73 3 -82 c2 -54 -1 -82 -8 -82 -6 0 -106 30 -223 66 -117 37 -220 69 -229 71 -15 5 -18 18 -18 89 0 46 1 84 3 84 1 0 108 -33 237 -73z m-426 -498 c35 -41 34 -83 -3 -120 -60 -60 -150 -22 -151 64 0 83 100 120 154 56z m633 -179 c8 0 33 -63 33 -84 0 -36 -39 -76 -81 -82 -50 -8 -99 33 -99 83 0 19 5 43 11 54 16 30 66 48 103 38 17 -5 32 -9 33 -9z" />
                <path d="M2608 4526 c-72 -19 -142 -81 -166 -145 -7 -21 -15 -22 -167 -26 -179 -4 -264 -15 -409 -51 -437 -108 -833 -426 -1040 -834 -126 -250 -176 -464 -176 -763 l0 -180 -157 -241 c-86 -133 -163 -259 -171 -281 -16 -47 -11 -129 12 -173 27 -52 72 -85 198 -147 l123 -60 23 -130 c65 -377 73 -410 107 -483 61 -128 180 -231 322 -279 37 -12 111 -17 320 -22 263 -6 273 -7 294 -28 17 -17 31 -63 60 -200 33 -155 41 -181 64 -200 l26 -23 783 0 c777 0 784 0 810 21 37 29 35 54 -25 335 -60 283 -69 376 -45 494 26 127 51 178 239 488 204 335 255 433 308 592 98 292 108 642 28 940 -102 381 -347 723 -676 943 l-93 62 7 67 c9 98 -9 151 -71 213 -32 32 -66 55 -91 63 -34 10 -207 37 -355 56 -19 2 -56 -1 -82 -8z m311 -186 c94 -14 131 -38 131 -85 0 -23 -174 -1218 -186 -1277 l-5 -26 -52 23 c-89 39 -197 58 -308 53 -81 -3 -99 -1 -99 10 0 32 180 1240 190 1275 8 28 19 42 41 51 31 13 46 12 288 -24z m-516 -147 c2 -5 -37 -284 -87 -620 l-91 -613 -64 -37 c-82 -49 -197 -171 -243 -259 -61 -116 -82 -203 -82 -329 0 -127 17 -204 69 -310 88 -180 260 -321 455 -372 99 -26 265 -23 360 6 226 69 400 236 476 456 25 71 28 95 29 210 0 109 -4 142 -23 205 -30 94 -77 181 -143 259 l-51 62 81 551 c45 304 83 554 85 555 7 7 148 -101 219 -167 425 -397 575 -987 396 -1551 -42 -132 -107 -256 -311 -591 -143 -234 -181 -305 -207 -382 -65 -198 -65 -316 3 -639 l43 -207 -680 2 -681 3 -27 130 c-32 157 -45 191 -94 240 -68 67 -79 69 -385 75 -275 5 -275 5 -335 33 -78 37 -118 68 -155 123 -46 65 -55 100 -109 405 -27 152 -53 285 -59 295 -6 11 -70 47 -149 83 -143 65 -173 87 -173 126 0 13 64 121 143 241 78 121 154 237 167 259 24 39 25 48 32 280 5 188 11 259 26 326 97 410 338 742 695 955 172 102 412 178 611 193 139 11 254 12 259 4z m256 -1338 c93 -22 177 -71 251 -145 316 -315 135 -848 -310 -912 -149 -22 -314 31 -429 138 -138 127 -202 307 -172 480 55 314 352 511 660 439z" />
                <path d="M988 2550 c-25 -26 -29 -36 -24 -63 15 -77 177 -146 315 -134 109 9 226 66 245 119 13 37 -8 83 -46 99 -27 11 -36 9 -96 -22 -58 -30 -76 -34 -138 -34 -61 1 -81 6 -133 33 -34 18 -68 32 -77 32 -9 0 -29 -14 -46 -30z" />
              </g>
            </svg>

            <div className="grow mx-4 flex items-center justify-start space-x-2">
              <p className="mb-0.5 text-[#fff] text-xs font-semibold capitalize">
                {music.tab_heading}
              </p>
              {audioState.src === music.tab_content_music && (
                <div id="bars" className="relative">
                  <div
                    className="bar"
                    style={{
                      animationPlayState: audioState.playing
                        ? "running"
                        : "paused",
                    }}
                  />
                  <div
                    className="bar"
                    style={{
                      animationPlayState: audioState.playing
                        ? "running"
                        : "paused",
                    }}
                  />
                  <div
                    className="bar"
                    style={{
                      animationPlayState: audioState.playing
                        ? "running"
                        : "paused",
                    }}
                  />
                </div>
              )}
            </div>
            {audioState.src === music.tab_content_music &&
            audioState.playing ? (
              <PauseIcon className="shrink-0 w-[30px] h-[30px] p-1 rounded-full text-white bg-[#390e73]" />
            ) : (
              <PlayIcon className="shrink-0 w-[30px] h-[30px] p-1 rounded-full text-white bg-[#390e73]" />
            )}
          </button>
        ))}
      </div>
      <AudioPlayer
        className="fixed left-0 right-0 bottom-[4.10rem] z-50"
        style={{
          display: audioState.src?.length > 0 ? "block" : "none",
        }}
        layout="horizontal"
        customControlsSection={["MAIN_CONTROLS", "VOLUME_CONTROLS"]}
        ref={playerRef}
        src={audioState.src}
        muted={false}
        loop={false}
        autoPlay
        autoPlayAfterSrcChange
        onLoadedData={() => {
          playerRef.current.audio.current.play();
        }}
        onPlay={() => {
          setAudioState((s) => ({ ...s, playing: true }));
        }}
        onPause={() => {
          setAudioState((s) => ({ ...s, playing: false }));
        }}
        onEnded={() => {
          playerRef.current.audio.current.pause();
          playerRef.current.audio.current.currentTime = 0;
          playerRef.current.audio.current.src = "";
          setAudioState({ playing: false, src: "" });
        }}
      />
    </div>
  );
};

export default RelaxationMusic;
